<!--
K线图表组件 - 支持价格标记线功能

功能特性：
1. 右侧显示带背景色的最新价格标签框
2. 图表内绘制横向虚线对齐该价格
3. 颜色根据价格涨跌变化（上涨绿色，下跌红色）
4. 价格框随数据实时更新

使用方法：
<chart-component
  :id="currencyId"
  :bit-name="bitName"
  :show-chart="true"
  :latest-price="currentPrice"
  :price-direction="priceChangeDirection"
/>

Props说明：
- latest-price: 最新价格（数字类型）
- price-direction: 价格变化方向
  * 1 = 上涨（显示绿色）
  * -1 = 下跌（显示红色）
  * 0 = 无变化（显示灰色）

示例代码：
data() {
  return {
    currentPrice: 104100,
    priceChangeDirection: 1  // 1=上涨, -1=下跌, 0=无变化
  }
}
-->
<template>
  <div class="echart-container">
    <div class="time-line flex-center-between">
      <div class="flex-center">
        <div class="tab">{{ $t('fen-shi') }}</div>
        <div class="tab" v-for="(item, i) in showTimeList" :key="i" :class="echartsTime == item.time ? 'active' : ''" @click="changeTime(item)">
          {{item.text}}
        </div>
        <div class="tab active" v-if="otherTime">{{otherTime}}</div>
        <div class="tab flex-center more" @click="showMoreBox">
          <img :src="downUrl" alt=""  :class="showMore ? 'show' : ''">
          <div class="option-box" :class="showMore ? 'show' : ''">
            <div class="option" v-for="(item, i) in timeList" :key="i" :class="echartsTime == item.time ? 'active' : ''" @click.stop="changeTime(item, true, i)">
              {{item.text}}
            </div>
          </div>
        </div>
      </div>
      <div class="flex-center">
        <div class="name">Trading view</div>
        <div class="gray">{{ $t('shen-du-tu') }}</div>
      </div>
    </div>

    <div class="echart-box" id="echartDom" ></div>
  </div>
</template>
<script>
import { Popup } from 'vant'
import * as echarts from 'echarts'
import { kLine } from '@/api/trade'
export default {
  components: {
    Popup
  },
  data() {
    return {
      downUrl: require('../../assets/imgs/icon-arrow-down2.png'),
      leftArrow: require('../../assets/imgs/icon-back.png'),
      timeIndex: 0,
      showMore: false,
      echartsTime: 'm1',
      echartsTimeName: '',
      timeList: [
        {
          time: 'm1',
          text: this.i18n.t('chart_page.time1')
        },
        {
          time: 'm3',
          text: this.i18n.t('chart_page.time2')
        },
        {
          time: 'm5',
          text: this.i18n.t('chart_page.time3')
        },
        {
          time: 'm15',
          text: this.i18n.t('chart_page.time4')
        },
        {
          time: 'm30',
          text: this.i18n.t('chart_page.time5')
        },
        {
          time: 'h1',
          text: this.i18n.t('chart_page.time6')
        },
        // {
        //   time: 'h2',
        //   text: this.i18n.t('chart_page.time7')
        // },
        // {
        //   time: 'h4',
        //   text: this.i18n.t('chart_page.time8')
        // },
        // {
        //   time: 'h6',
        //   text: this.i18n.t('chart_page.time9')
        // },
        // {
        //   time: 'h12',
        //   text: this.i18n.t('chart_page.time10')
        // },
        // {
        //   time: 'd1',
        //   text: this.i18n.t('chart_page.time11')
        // },
      ],
      showTimeList: [],
      moreTimeList: [],
      xDataList: [],
      startValue: 0,
      endValue: 59,
      isMaxLeft: true,
      isMinLeft: true,
      kLineData: [],
      dataBak: [],
      volBak: [],
      echartsObj: null,
      timer: '',
      isLoading: false,
      otherTime: '',
      currentPrice: 104100,
      priceChangeDirection: 1,  // 1=上涨, -1=下跌, 0=无变化
      lastPriceColor: '#07C67B' // 记录上次的价格颜色，默认绿色
    }
  },
  props: {
    id: [String, Number],
    showChart: Boolean,
    bitName: String,
    // 最新价格（用于显示价格标记线）
    latestPrice: {
      type: [String, Number],
      default: 0
    },
    // 价格变化方向（1=上涨, -1=下跌, 0=无变化）
    priceDirection: {
      type: Number,
      default: 0
    }
  },
  watch: {
    id(val) {
      if (val && !this.isLoading) {
        this.init()
      }
    },
    showChart(val) {
      if (val && !this.isLoading) {
        this.$nextTick(() => {
          this.init()
        }, 100)
      }
    },
    // 监听最新价格变化，更新价格标记线
    latestPrice: {
      handler(newPrice) {
        // 改进价格验证逻辑，特别处理极小数值
        const price = parseFloat(newPrice)
        if (newPrice && !isNaN(price) && price > 0 && this.echartsObj) {
          this.updatePriceMarkLine(newPrice)
        }
      },
      immediate: true
    },
    // 监听价格方向变化
    priceDirection: {
      handler(newDirection, oldDirection) {
        const price = parseFloat(this.latestPrice)
        if (this.latestPrice && !isNaN(price) && price > 0 && this.echartsObj && newDirection !== oldDirection) {
          this.updatePriceMarkLine(this.latestPrice)
        }
      },
      immediate: true
    },
    // 监听币种名称变化，重新初始化
    bitName: {
      handler(newName, oldName) {
        if (newName && newName !== oldName && this.echartsObj) {
          // 币种切换时重置为默认绿色（首次加载效果）
          this.lastPriceColor = '#07C67B'

          // 延迟一下，确保数据已更新
          this.$nextTick(() => {
            const price = parseFloat(this.latestPrice)
            if (this.latestPrice && !isNaN(price) && price > 0) {
              this.updatePriceMarkLine(this.latestPrice)
            }
          })
        }
      }
    }
  },
  mounted() {
    this.showTimeList = this.timeList.slice(0, 5)
    this.moreTimeList = this.timeList.slice(5)
    if (this.id) {
      this.init()
    }
    let dom = document.getElementById('echartDom')
    if (dom) {
      dom.addEventListener('touchend', this.hideTooltip)
    }
  },
  methods: {
    formatPrice(price) {
      if (!price && price !== 0) return '--'
      let num = parseFloat(price)

      // 对于Y轴标签，需要处理极小数值，统一最大8位小数
      if (num >= 1000) {
        return num.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 8  // 改为8位
        })
      } else if (num >= 100) {
        return num.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 8  // 改为8位
        })
      } else if (num >= 1) {
        return num.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 8  // 改为8位
        })
      } else if (num >= 0.01) {
        return num.toLocaleString('en-US', {
          minimumFractionDigits: 4,
          maximumFractionDigits: 8
        })
      } else {
        // 对于极小数值，使用科学计数法或显示更多小数位
        if (num < 0.00001) {
          return num.toExponential(3) // 科学计数法，保留3位有效数字
        } else {
          return num.toLocaleString('en-US', {
            minimumFractionDigits: 6,
            maximumFractionDigits: 8  // 改为8位，保持一致
          })
        }
      }
    },
    // 专门用于价格标记线的格式化函数
    formatPriceForMarkLine(price) {
      if (!price && price !== 0) return '--'
      let num = parseFloat(price)

      // 针对极小数值进行特殊处理，最大8位小数
      if (num >= 10000) {
        return num.toFixed(2) // 大数值保留2位小数
      } else if (num >= 1000) {
        return num.toFixed(3) // 保留3位小数
      } else if (num >= 100) {
        return num.toFixed(4) // 保留4位小数
      } else if (num >= 1) {
        return num.toFixed(4) // 保留4位小数
      } else if (num >= 0.1) {
        return num.toFixed(6) // 0.1到1之间保留6位小数
      } else if (num >= 0.01) {
        return num.toFixed(7) // 0.01到0.1之间保留7位小数
      } else if (num >= 0.001) {
        return num.toFixed(8) // 0.001到0.01之间保留8位小数
      } else {
        // 对于极小数值（如SHIB），动态计算需要的小数位数，最大8位
        let str = num.toString()
        if (str.includes('e')) {
          // 科学计数法处理，最大8位小数
          return num.toFixed(8)
        } else {
          // 找到第一个非零数字的位置
          let match = str.match(/0\.0*[1-9]/)
          if (match) {
            let zeros = match[0].match(/0/g).length - 1 // 减去小数点前的0
            return num.toFixed(Math.min(zeros + 4, 8)) // 保留到第一个非零数字后4位，最多8位
          } else {
            return num.toFixed(8)
          }
        }
      }
    },
    // 计算移动平均线
    calculateMA(data, period) {
      let result = []
      for (let i = 0; i < data.length; i++) {
        if (i < period - 1) {
          result.push(null) // 前面不足周期的数据设为null
        } else {
          let sum = 0
          for (let j = 0; j < period; j++) {
            sum += parseFloat(data[i - j][1]) // 使用收盘价计算
          }
          result.push(sum / period)
        }
      }
      return result
    },
    init() {
      this.isLoading = true
      let form = new FormData()
      form.append('CurrencyId', this.id)
      form.append('Count', 1000)
      form.append('TimeLine', this.echartsTime)
      kLine(form).then(res => {
        this.isLoading = false
        const moment = require('moment-timezone');
        const serverTimezone = this.$store.state.timeZone;
        res.data.forEach(v => {
            v.CreatedAt = moment.tz(v.CreatedAt, serverTimezone).format('MM-DD HH:mm');
            v.UpdatedAt = moment.tz(v.UpdatedAt, serverTimezone).format('MM-DD HH:mm');
        })
        this.kLineData = res.data
        sessionStorage.setItem('kLineData', JSON.stringify(this.kLineData))
        this.initChart()
      })
    },
    initChart() {
      var echartsObj = null
      if (this.echartsObj) {
        echartsObj = this.echartsObj
      } else {
        echartsObj = echarts.init(document.getElementById('echartDom'));
      }

      let data = this.kLineData.map(v => {
        return [v.Open, v.Close, v.Low, v.High]
      })
      let volumes = this.kLineData.map(v => {
        return v.Volume
      })
      this.xDataList = this.kLineData.map(v => {
        return v.UpdatedAt
      })

      data.reverse()
      volumes.reverse()

      this.dataBak = data
      this.volBak = volumes
      this.xDataList.reverse()
      this.startValue = data.length - 60
      this.endValue = data.length - 1

      // 计算移动平均线数据
      let ma5Data = this.calculateMA(data, 5)
      let ma10Data = this.calculateMA(data, 10)
      let ma20Data = this.calculateMA(data, 20)
      let ma30Data = this.calculateMA(data, 30)

      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            z: 10,
            snap: true,
            crossStyle: {
              color: '#9197A4'
            },
            lineStyle: {
              color: '#9197A4'
            },
            label: {
              backgroundColor: '#353945',
              formatter: (params) => {
                // 格式化十字线上的价格显示
                if (params.axisDimension === 'y') {
                  return this.formatPrice(params.value)
                }
                return params.value
              }
            }
          },
          position: function (point, params, dom, rect, size) {
            // 动态调整tooltip位置，避免遮挡图表内容
            let x = point[0]
            let y = point[1]

            // 如果鼠标在图表右侧，tooltip显示在左侧
            if (x > size.viewSize[0] / 2) {
              x = point[0] - size.contentSize[0] - 20
            } else {
              x = point[0] + 20
            }

            // 如果鼠标在图表上方，tooltip显示在下方
            if (y < 150) {
              y = point[1] + 20
            } else {
              y = point[1] - size.contentSize[1] - 20
            }

            return [x, y]
          },
          backgroundColor: 'rgba(53, 57, 69, 0.95)',
          borderColor: 'rgba(119, 126, 144, 0.3)',
          borderWidth: 1,
          textStyle: {
            color: '#E4E4E7',
            fontSize: '12px',
            lineHeight: 18
          },
          padding: [8, 12],
          formatter: (params) => {
            if (!params || params.length === 0) return ''

            let index = params[0].dataIndex
            let open = parseFloat(data[index][0])
            let close = parseFloat(data[index][1])
            let low = parseFloat(data[index][2])
            let high = parseFloat(data[index][3])
            let vol = parseFloat(parseFloat(this.kLineData[index].Volume).toFixed(4))
            let color = close > open ? '#07C67B' : '#FF5C51'

            let space = parseFloat((close - open).toFixed(2))
            let percent = parseFloat(((close - open) / open * 100).toFixed(2))

            // 获取MA数据
            let ma5 = ma5Data[index] ? this.formatPrice(ma5Data[index]) : '--'
            let ma10 = ma10Data[index] ? this.formatPrice(ma10Data[index]) : '--'
            let ma20 = ma20Data[index] ? this.formatPrice(ma20Data[index]) : '--'
            let ma30 = ma30Data[index] ? this.formatPrice(ma30Data[index]) : '--'

            // 优化样式的tooltip内容
            let result = `
              <div style="margin-bottom: 8px; font-weight: bold; color: #E4E4E7; border-bottom: 1px solid rgba(119, 126, 144, 0.3); padding-bottom: 4px;">
                ${this.bitName}/USDT
              </div>
              <div style="display: flex; justify-content: space-between; margin-bottom: 3px;">
                <span style="color: #9CA3AF;">${this.$t('chart_page.open')}:</span>
                <span style="color: ${color}; font-weight: 500;">${this.formatPrice(open)}</span>
              </div>
              <div style="display: flex; justify-content: space-between; margin-bottom: 3px;">
                <span style="color: #9CA3AF;">${this.$t('chart_page.high')}:</span>
                <span style="color: ${color}; font-weight: 500;">${this.formatPrice(high)}</span>
              </div>
              <div style="display: flex; justify-content: space-between; margin-bottom: 3px;">
                <span style="color: #9CA3AF;">${this.$t('chart_page.low')}:</span>
                <span style="color: ${color}; font-weight: 500;">${this.formatPrice(low)}</span>
              </div>
              <div style="display: flex; justify-content: space-between; margin-bottom: 3px;">
                <span style="color: #9CA3AF;">${this.$t('chart_page.close')}:</span>
                <span style="color: ${color}; font-weight: 500;">${this.formatPrice(close)}</span>
              </div>
              <div style="display: flex; justify-content: space-between; margin-bottom: 6px;">
                <span style="color: #9CA3AF;">${this.$t('chart_page.vol')}:</span>
                <span style="color: ${color}; font-weight: 500;">${vol.toLocaleString()}</span>
              </div>
              <div style="display: flex; justify-content: space-between; margin-bottom: 6px; padding-top: 4px; border-top: 1px solid rgba(119, 126, 144, 0.3);">
                <span style="color: #9CA3AF;">${this.$t('chart_page.change')}:</span>
                <span style="color: ${color}; font-weight: 500;">${space > 0 ? '+' : ''}${space} (${percent}%)</span>
              </div>
              <div style="border-top: 1px solid rgba(119, 126, 144, 0.3); padding-top: 6px;">
                <div style="display: flex; justify-content: space-between; margin-bottom: 2px;">
                  <span style="color: #FF6B35;">MA5:</span>
                  <span style="color: #FF6B35; font-weight: 500;">${ma5}</span>
                </div>
                <div style="display: flex; justify-content: space-between; margin-bottom: 2px;">
                  <span style="color: #4ECDC4;">MA10:</span>
                  <span style="color: #4ECDC4; font-weight: 500;">${ma10}</span>
                </div>
                <div style="display: flex; justify-content: space-between; margin-bottom: 2px;">
                  <span style="color: #FFE66D;">MA20:</span>
                  <span style="color: #FFE66D; font-weight: 500;">${ma20}</span>
                </div>
                <div style="display: flex; justify-content: space-between;">
                  <span style="color: #A8E6CF;">MA30:</span>
                  <span style="color: #A8E6CF; font-weight: 500;">${ma30}</span>
                </div>
              </div>
            `
            return result
          }
        },
        legend: {
          data: [this.$t('chart_page.kline'), 'MA5', 'MA10', 'MA20', 'MA30'],
          textStyle: {
            color: '#ADB1B8',
            fontSize: 12
          },
          top: 10,
          left: 10
        },
        grid: [
          {
            left: 20,
            right: 90,
            top: 50,
            height: 220
          },
          {
            left: 20,
            right: 90,
            height: 90,
            top: 270
          }
        ],
        xAxis: [
          {
            type: 'category',
            data: this.xDataList,
            boundaryGap: false,
            splitLine: { show: false },
            axisLine: {
              onZero: false,
              show: true,
              lineStyle: {
                color: '#353945',
                width: 1
              }
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#23262F',
                width: 1
              }
            }
          },
          {
            type: 'category',
            gridIndex: 1,
            data: this.xDataList,
            boundaryGap: false,
            splitLine: { show: false },
            axisLine: {
              onZero: false,
              show: false,
              lineStyle: {
                width: 1
              }
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              color: '#777E90'
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#23262F',
                width: 1
              }
            }
          }
        ],
        yAxis: [
          {
            position: 'right',
            scale: true,
            axisLabel: {
              show: true,
              color: '#ADB1B8',
              formatter: (value) => {
                return this.formatPrice(value)
              }
            },
            axisLine: {
              show: true,
              color: '#777E90'
            },
            splitLine: {
              lineStyle: {
                color: '#23262F',
                width: 1
              }
            }
          },
          {
            position: 'right',
            gridIndex: 1,
            splitNumber: 2,
            axisLabel: {
              show: true,
              color: '#ADB1B8',
              showMaxLabel: false,
              formatter: (value) => {
                if (value >= 1000000) {
                  return (value / 1000000).toFixed(1) + 'M'
                } else if (value >= 1000) {
                  return (value / 1000).toFixed(1) + 'K'
                }
                return value.toFixed(0)
              }
            },
            axisLine: {
              show: true,
              color: '#777E90'
            },
            splitLine: {
              lineStyle: {
                color: '#23262F',
                width: 1
              }
            }
          }
        ],
        dataZoom: [
          {
            type: 'inside',
            filterMode: 'filter',
            xAxisIndex: [0, 1],
            startValue: this.startValue,
            endValue: this.endValue
          },
          {
            type: 'inside',
            filterMode: 'filter',
            startValue: this.startValue,
            endValue: this.endValue,
            xAxisIndex: [0, 1],
          },
        ],
        series: this.getSerie(data, volumes, ma5Data, ma10Data, ma20Data, ma30Data)
      };

      // 添加价格标记线配置
      if (this.latestPrice && this.latestPrice > 0) {
        this.addPriceMarkLine(option, this.latestPrice)
      }

      echartsObj.on('mouseup', this.hideTooltip);
      echartsObj.setOption(option)
      this.echartsObj = echartsObj

      // 初始化完成后，检查是否需要显示价格标记线
      this.$nextTick(() => {
        if (this.latestPrice && this.latestPrice > 0) {
          this.updatePriceMarkLine(this.latestPrice)
        }
      })
    },
    changeTime(data, isMore, index) {
      this.echartsTime = data.time
      if (isMore) {
        this.echartsTimeName = data.text
        if (index > 4) {
          this.otherTime = data.text
        } else {
          this.otherTime = ''
        }
      } else {
        this.echartsTimeName = ''
        this.otherTime = ''
      }
      this.showMore = false
      this.init()
    },
    showMoreBox() {
      this.showMore = !this.showMore
    },
    cancelHide() {
      clearTimeout(this.timer)
    },
    hideTooltip() {
      this.timer = setTimeout(() => {
        this.echartsObj.dispatchAction({
          type: 'hideTip',
        })
        this.echartsObj.dispatchAction({
          type: 'updateAxisPointer',
          currTrigger: 'leave'
        })
      }, 2000)
    },
    getSerie(data, volumes, ma5Data, ma10Data, ma20Data, ma30Data) {
      return [
        {
          name: this.$t('chart_page.kline'),
          type: 'candlestick',
          itemStyle: {
            color: '#07C67B',
            color0: '#FF5C51',
            borderColor: '#20B26C',
            borderColor0: '#EF454A',
          },
          barMaxWidth: 6,
          data: data,
        },
        {
          name: 'Volume',
          type: 'bar',
          xAxisIndex: 1,
          yAxisIndex: 1,
          barMaxWidth: 6,
          itemStyle: {
            color: (param) => {
              let index = param.dataIndex
              let open = data[index][0]
              let close = data[index][1]
              return close > open ? 'rgba(7, 198, 123, .8)' : 'rgba(255, 92, 81, .8)'
            },
            borderWidth: 0,
          },
          emphasis: {
          },
          data: volumes
        },
        {
          name: 'MA5',
          type: 'line',
          data: ma5Data,
          smooth: true,
          symbol: 'none',
          lineStyle: {
            color: '#FF6B35',
            width: 1
          }
        },
        {
          name: 'MA10',
          type: 'line',
          data: ma10Data,
          smooth: true,
          symbol: 'none',
          lineStyle: {
            color: '#4ECDC4',
            width: 1
          }
        },
        {
          name: 'MA20',
          type: 'line',
          data: ma20Data,
          smooth: true,
          symbol: 'none',
          lineStyle: {
            color: '#FFE66D',
            width: 1
          }
        },
        {
          name: 'MA30',
          type: 'line',
          data: ma30Data,
          smooth: true,
          symbol: 'none',
          lineStyle: {
            color: '#A8E6CF',
            width: 1
          }
        }
      ]
    },
    // 更新价格标记线
    updatePriceMarkLine(newPrice) {
      if (!newPrice || !this.echartsObj) {
        return
      }

      try {
        const price = parseFloat(newPrice)
        const priceColor = this.getPriceColor()

        // 检查价格是否有效 - 改进极小数值判断
        if (isNaN(price) || price <= 0) {
          return
        }

        // 获取当前图表配置
        const currentOption = this.echartsObj.getOption()

        // 构建价格标记线配置
        const markLineConfig = {
          symbol: 'none',
          silent: true,
          animation: false,
          precision: 8, // 增加精度设置
          label: {
            show: true,
            position: 'insideEndTop',
            formatter: () => '',
            backgroundColor: 'transparent'
          },
          lineStyle: {
            type: [5, 5], // 虚线样式
            color: priceColor,
            width: 2, // 增加线宽，更容易看到
            opacity: 0.9 // 增加不透明度
          },
          data: [{
            yAxis: price,
            name: 'currentPrice',
            label: {
              show: true,
              position: 'end', // 改回end位置，尽量靠右
              formatter: this.formatPriceForMarkLine(price),
              color: '#FFFFFF',
              backgroundColor: priceColor,
              padding: [6, 14], // 增加内边距
              borderRadius: 6,
              fontSize: 13, // 增加字体大小
              fontWeight: 'bold',
              borderColor: priceColor,
              borderWidth: 2,
              offset: [-5, 0], // 只向左偏移5像素，尽量靠右但避免被截断
              // 添加阴影效果，增强可见性
              shadowColor: 'rgba(0, 0, 0, 0.3)',
              shadowBlur: 4,
              shadowOffsetX: 2,
              shadowOffsetY: 2
            }
          }]
        }

        // 确保K线系列存在并更新价格标记线
        if (currentOption.series && currentOption.series[0]) {
          // 创建新的系列配置
          const newSeries = [...currentOption.series]

          // 更新第一个系列（K线）的markLine
          newSeries[0] = {
            ...newSeries[0],
            markLine: markLineConfig
          }

          // 应用更新
          this.echartsObj.setOption({
            series: newSeries
          }, false) // false表示不合并，直接替换

        } else {
          return
        }

      } catch (error) {
        // 错误时的降级方案：强制重新设置整个标记线
        try {
          this.echartsObj.setOption({
            series: [{
              markLine: {
                symbol: 'none',
                lineStyle: {
                  type: [5, 5],
                  color: this.getPriceColor(),
                  width: 2
                },
                data: [{
                  yAxis: parseFloat(newPrice),
                  label: {
                    show: true,
                    position: 'end',
                    formatter: this.formatPriceForMarkLine(parseFloat(newPrice)),
                    color: '#FFFFFF',
                    backgroundColor: this.getPriceColor(),
                    padding: [6, 14],
                    borderRadius: 6,
                    offset: [-5, 0]
                  }
                }]
              }
            }]
          }, false)
        } catch (fallbackError) {
          // 静默处理降级方案失败
        }
      }
    },

    // 添加价格标记线到初始配置
    addPriceMarkLine(option, price) {
      try {
        const priceColor = this.getPriceColor()
        const numPrice = parseFloat(price)

        // 在K线系列中添加价格标记线
        if (option.series && option.series[0]) {
          option.series[0].markLine = {
            symbol: 'none',
            silent: true,
            animation: false,
            precision: 8, // 增加精度设置
            label: {
              show: true,
              position: 'insideEndTop',
              formatter: () => '',
              backgroundColor: 'transparent'
            },
            lineStyle: {
              type: [5, 5], // 虚线样式 [实线长度, 空白长度]
              color: priceColor,
              width: 2, // 增加线宽，与updatePriceMarkLine保持一致
              opacity: 0.9 // 增加不透明度
            },
            data: [{
              yAxis: numPrice,
              name: 'currentPrice',
              label: {
                show: true,
                position: 'end', // 改回end位置，尽量靠右
                formatter: this.formatPriceForMarkLine(numPrice), // 使用新的格式化函数
                color: '#FFFFFF',
                backgroundColor: priceColor,
                padding: [6, 14], // 增加内边距，与updatePriceMarkLine保持一致
                borderRadius: 6,
                fontSize: 13, // 增加字体大小
                fontWeight: 'bold',
                borderColor: priceColor,
                borderWidth: 2,
                offset: [-5, 0], // 只向左偏移5像素，尽量靠右但避免被截断
                // 添加阴影效果，增强可见性
                shadowColor: 'rgba(0, 0, 0, 0.3)',
                shadowBlur: 4,
                shadowOffsetX: 2,
                shadowOffsetY: 2
              }
            }],
          }
        } else {
          return
        }

      } catch (error) {
        // 静默处理错误
      }
    },

    // 获取价格颜色（根据涨跌方向）
    getPriceColor() {
      let color
      switch (this.priceDirection) {
        case 1:  // 上涨
          color = '#07C67B'  // 绿色
          break
        case -1: // 下跌
          color = '#FF5C51'  // 红色
          break
        default: // 无变化
          color = this.lastPriceColor // 使用上次的颜色
          break
      }

      // 当价格有明确涨跌时，更新记录的颜色
      if (this.priceDirection === 1 || this.priceDirection === -1) {
        this.lastPriceColor = color
      }

      return color
    }
  }
}
</script>